var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import useUniqueId from "../../Hooks/useUniqueId";
/**
 * It's tricky to show a bootstrap custom checkbox without any text next to it.  This component handles that trickery while
 * still adding an accessible label
 */
const LoneCheckbox = (_a) => {
    var { checked, label, className, onChange, disabled } = _a, otherProps = __rest(_a, ["checked", "label", "className", "onChange", "disabled"]);
    const [checkId] = useUniqueId();
    return (_jsxs("div", Object.assign({}, otherProps, { className: "custom-control custom-checkbox " + (className || ""), children: [_jsx("input", { type: "checkbox", className: "custom-control-input", id: checkId, 
                // @ts-expect-error - TS2322 - Type 'boolean | null | undefined' is not assignable to type 'boolean | undefined'.
                checked: checked, 
                // @ts-expect-error - TS2322 - Type '((arg1: ChangeEventHandler<Element>) => void) | null | undefined' is not assignable to type 'ChangeEventHandler<HTMLInputElement> | undefined'.
                onChange: onChange, 
                // @ts-expect-error - TS2322 - Type 'boolean | null | undefined' is not assignable to type 'boolean | undefined'.
                disabled: disabled, "aria-label": label || "Select this item" }), _jsx("label", { className: "custom-control-label", htmlFor: checkId, children: "\u00A0" })] })));
};
export default LoneCheckbox;
